"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.angle = exports.add = exports.scale = exports.normalize = exports.magnitude = void 0;
// TODO: is this deterministic
var magnitude = function (v) {
    return Math.sqrt(v.x * v.x + v.y * v.y);
};
exports.magnitude = magnitude;
var normalize = function (v) {
    var mag = exports.magnitude(v);
    return {
        x: v.x / mag,
        y: v.y / mag,
    };
};
exports.normalize = normalize;
var scale = function (v, s) {
    return {
        x: v.x * s,
        y: v.y * s,
    };
};
exports.scale = scale;
var add = function (v1, v2) {
    return {
        x: v1.x + v2.x,
        y: v1.y + v2.y,
    };
};
exports.add = add;
var angle = function (v1) {
    return Math.atan2(v1.y, v1.x);
};
exports.angle = angle;
